import React, { useEffect } from 'react';
import styled from '@emotion/styled';

import processRealtimeData from '../../utilities/ProcessRealtimeZoneHelper';

import './ZoneCard.scss';

const ZoneCard = ({ zoneRealtimeData, selectZone, setZoneHealth }) => {
  const formattedZoneRealtime = processRealtimeData(zoneRealtimeData);
  let hasTemperature = formattedZoneRealtime.currentTemperature !== 'N/A';

  useEffect(() => {
    setZoneHealth(formattedZoneRealtime.zoneStatusCSS);
  }, [zoneRealtimeData]);

  return (
    <>
      <tr>
        <td className="location " onClick={selectZone}>
          <div className={'zone-health-indicator ' + formattedZoneRealtime.zoneStatusCSS}></div>
          {zoneRealtimeData && zoneRealtimeData.longThermalZoneDisplayName}
        </td>

        <td className="status">
          <div className={'status ' + formattedZoneRealtime.zoneStatusCSS}>
            {formattedZoneRealtime.zoneStatus}
          </div>
        </td>

        <td className="temp-range">
          {hasTemperature && (
            <div className="zone-thermostat-container">
              <p className="current">{formattedZoneRealtime.currentTemperature}°</p>

              <div>
                <p className="range">
                  {formattedZoneRealtime.temperatureLowerBound !== null &&
                    formattedZoneRealtime.temperatureUpperBound !== null && (
                      <>
                        {formattedZoneRealtime.temperatureLowerBound}° -{' '}
                        {formattedZoneRealtime.temperatureUpperBound}°
                      </>
                    )}
                </p>
                {formattedZoneRealtime.temperatureSetting && (
                  <p className="setting">{formattedZoneRealtime.temperatureSetting}</p>
                )}
              </div>
            </div>
          )}
        </td>

        <td className="schedule">{formattedZoneRealtime.scheduleOrOverride}</td>

        <td className="activity">{formattedZoneRealtime.activityState}</td>

        <td className="keypad">{formattedZoneRealtime.keypadLock}</td>

        <td className="managed">{formattedZoneRealtime.controlState}</td>
      </tr>
    </>
  );
};

export default ZoneCard;
